import { BetPriceType, Option } from "../../types/common";
import { TeamName } from "../../components/Typography";
import { CR_SCORE, HT_FT, HT_FT_OE, TTG } from "../../constants/common";

export type BettingTeamNameProps = {
  isGoodTeam: boolean;
  bettingTeamName: string;
  betPriceType: BetPriceType;
  outcomeId?: string;
  option?: Option;
};

const BettingTeamName = (props: BettingTeamNameProps) => {
  switch (props.betPriceType) {
    case "oe":
      if (props.option === 0) {
        return (
          <TeamName className="text-sm" isGoodTeam>
            Odd
          </TeamName>
        );
      }
      return (
        <TeamName className="text-sm" isGoodTeam>
          Even
        </TeamName>
      );
    case "ou":
    case "ou1st":
    case "tob":
    case "tob1st":
    case "ato":
    case "hto":
      if (props.option === 0) {
        return (
          <TeamName className="text-sm" isGoodTeam>
            Over
          </TeamName>
        );
      }
      return (
        <TeamName className="text-sm" isGoodTeam>
          Under
        </TeamName>
      );
    case "1h/cr":
    case "2h/cr":
    case "cr":
      return (
        <TeamName className="text-sm" isGoodTeam>
          {CR_SCORE[props.outcomeId ?? ""]}
        </TeamName>
      );
    case "1h/ttg":
    case "ttg":
      return (
        <TeamName className="text-sm" isGoodTeam>
          {TTG[props.outcomeId ?? ""]}
        </TeamName>
      );
    case "ht/ft":
      return (
        <TeamName className="text-sm" isGoodTeam>
          {HT_FT[props.outcomeId ?? ""]}
        </TeamName>
      );
    case "ht/ft/oe":
      return (
        <TeamName className="text-sm" isGoodTeam>
          {HT_FT_OE[props.outcomeId ?? ""]}
        </TeamName>
      );
    case "yn":
    case "hwn":
    case "awn":
      if (props.option === 0) {
        return (
          <TeamName className="text-sm" isGoodTeam>
            Yes
          </TeamName>
        );
      }
      return (
        <TeamName className="text-sm" isGoodTeam>
          No
        </TeamName>
      );
    default:
      return (
        <TeamName className="text-sm" isGoodTeam={props.isGoodTeam}>
          {props.bettingTeamName}
        </TeamName>
      );
  }
};

export default BettingTeamName;
